(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const runOnReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  const url = new URL(window.location.href);
  if (url.hash) {
    runOnReady(() => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    });
  }

  const hasTag = (tagString, value) => {
    if (!tagString || !value) return false;
    return tagString.includes(`|${value}|`);
  };

  const setupShopSortPlacement = (directory) => {
    const topbar = directory.querySelector('.shop-directory__topbar');
    const layout = directory.querySelector('.shop-directory__layout');
    const sort = directory.querySelector('.shop-directory__sort');
    const results = directory.querySelector('.shop-directory__results');

    if (!topbar || !layout || !sort || !results) return;

    const mobileMedia = window.matchMedia('(max-width: 989px)');

    const syncPlacement = () => {
      if (mobileMedia.matches) {
        layout.insertBefore(sort, results);
        return;
      }

      topbar.appendChild(sort);
    };

    syncPlacement();

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', syncPlacement);
      return;
    }

    mobileMedia.addListener(syncPlacement);
  };

  const setupShopDirectory = () => {
    const directories = document.querySelectorAll('[data-shop-directory]');
    if (!directories.length) return;

    directories.forEach((directory) => {
      setupShopSortPlacement(directory);

      const filterButtons = Array.from(directory.querySelectorAll('[data-shop-filter-value]'));
      const productGrid = directory.querySelector('[data-testid="product-grid"]');
      if (!productGrid || !filterButtons.length) return;
      const pagination = directory.querySelector('.blog-pagination, .pagination');

      const activePrimary = (directory.getAttribute('data-active-primary') || '').toLowerCase().trim();
      const activeSecondary = (directory.getAttribute('data-active-secondary') || '').toLowerCase().trim();
      const initialPage = new URL(window.location.href).searchParams.get('page') || '1';
      let filterRequestId = 0;
      let allPagesPromise = null;

      const cards = () => Array.from(productGrid.querySelectorAll('[data-shop-tags]'));

      const syncPagination = (value) => {
        if (!pagination) return;

        if (!value) {
          pagination.style.display = '';
          return;
        }

        pagination.style.display = 'none';
      };

      const loadedPages = () => {
        return new Set(
          cards()
            .map((card) => card.getAttribute('data-page'))
            .filter(Boolean)
        );
      };

      const fetchPage = async (page) => {
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('page', page);

        const response = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Unable to load collection page ${page}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextDirectory = doc.querySelector('[data-shop-directory]');
        const nextGrid = nextDirectory
          ? nextDirectory.querySelector('[data-testid="product-grid"]')
          : doc.querySelector('[data-testid="product-grid"]');
        if (!nextGrid) return [];

        return Array.from(nextGrid.querySelectorAll('[data-shop-tags]'));
      };

      const appendCards = (nextCards) => {
        const existingProductIds = new Set(cards().map((card) => card.getAttribute('data-product-id')));

        nextCards.flat().forEach((card) => {
          const productId = card.getAttribute('data-product-id');
          if (productId && existingProductIds.has(productId)) return;

          productGrid.appendChild(card.cloneNode(true));
          if (productId) existingProductIds.add(productId);
        });
      };

      const loadAllPages = () => {
        if (allPagesPromise) return allPagesPromise;

        const pageCount = Number.parseInt(productGrid.getAttribute('data-last-page') || '1', 10);
        if (Number.isNaN(pageCount) || pageCount <= 1) {
          allPagesPromise = Promise.resolve();
          return allPagesPromise;
        }

        const pages = loadedPages();
        const requests = [];
        for (let page = 1; page <= pageCount; page += 1) {
          if (pages.has(String(page))) continue;
          requests.push(fetchPage(page));
        }

        allPagesPromise = Promise.all(requests)
          .then(appendCards)
          .catch((error) => {
            allPagesPromise = null;
            throw error;
          });

        return allPagesPromise;
      };

      const setActiveButton = (nextValue) => {
        filterButtons.forEach((button) => {
          const value = (button.getAttribute('data-shop-filter-value') || '').toLowerCase().trim();
          const isActive = value === nextValue;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const applyFilter = (rawValue) => {
        const value = (rawValue || '').toLowerCase().trim();
        const scopedValue = activePrimary && value ? `${activePrimary},${value}` : '';

        cards().forEach((card) => {
          if (!value) {
            const cardPage = card.getAttribute('data-page') || '1';
            card.style.display = cardPage === initialPage ? '' : 'none';
            return;
          }

          const tags = (card.getAttribute('data-shop-tags') || '').toLowerCase();
          const matchesUnscoped = hasTag(tags, value);
          const matchesScoped = scopedValue ? hasTag(tags, scopedValue) : false;
          card.style.display = matchesUnscoped || matchesScoped ? '' : 'none';
        });

        syncPagination(value);
      };

      const applyFilterForValue = async (rawValue) => {
        const value = (rawValue || '').toLowerCase().trim();
        const requestId = (filterRequestId += 1);

        if (!value) {
          applyFilter(value);
          return;
        }

        try {
          await loadAllPages();
        } catch (error) {
          console.error(error);
        }

        if (requestId !== filterRequestId) return;

        applyFilter(value);
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = (button.getAttribute('data-shop-filter-value') || '').toLowerCase().trim();
          setActiveButton(value);
          applyFilterForValue(value);
        });
      });

      const observer = new MutationObserver(() => {
        const activeButton = directory.querySelector('[data-shop-filter-value].is-active');
        const value = activeButton ? activeButton.getAttribute('data-shop-filter-value') : '';
        applyFilter(value);
      });
      observer.observe(productGrid, { childList: true });

      const activeButton = directory.querySelector('[data-shop-filter-value].is-active');
      const fallbackValue = activeButton
        ? (activeButton.getAttribute('data-shop-filter-value') || '').toLowerCase().trim()
        : '';
      const initialValue = activeSecondary || fallbackValue;
      setActiveButton(initialValue);
      applyFilterForValue(initialValue);
    });

    const sortSelects = document.querySelectorAll('[data-shop-sort-select]');
    sortSelects.forEach((select) => {
      select.addEventListener('change', () => {
        if (select.form) select.form.submit();
      });
    });
  };

  runOnReady(setupShopDirectory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  const runContactConceptOnReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  runContactConceptOnReady(() => {
    const sections = document.querySelectorAll('.contact-concept');
    if (!sections.length) return;

    sections.forEach((section) => {
      const form = section.querySelector('.contact-concept__form');
      if (!form) return;

      const firstNameInput = form.querySelector('[data-contact-first-name]');
      const lastNameInput = form.querySelector('[data-contact-last-name]');
      const hiddenNameInput = form.querySelector('[data-contact-name-input]');
      const emailInput = form.querySelector('[data-contact-email-input]');
      const emailError = form.querySelector('[data-contact-email-error]');
      const errorSummary = form.querySelector('[data-contact-error-summary]');
      const errorSummaryText = form.querySelector('[data-contact-error-summary-text]');
      const phoneInput = form.querySelector('[data-contact-phone-input]');
      const fileInput = form.querySelector('[data-contact-file-input]');
      const fileLabel = form.querySelector('[data-contact-file-label]');
      const successDialog = form.querySelector('[data-contact-success-dialog]');
      if (!hiddenNameInput) return;

      const getPhoneDigits = (value) => value.replace(/\D/g, '');

      const formatNorthAmericanPhone = (value) => {
        const digits = getPhoneDigits(value);
        let localDigits = digits;
        let prefix = '';

        if (localDigits.length > 10 && localDigits.charAt(0) === '1') {
          prefix = '1 ';
          localDigits = localDigits.slice(1);
        }

        localDigits = localDigits.slice(0, 10);

        if (!localDigits.length) return prefix.trim();

        if (localDigits.length < 4) {
          return `${prefix}(${localDigits}`.trim();
        }

        if (localDigits.length < 7) {
          return `${prefix}(${localDigits.slice(0, 3)}) ${localDigits.slice(3)}`.trim();
        }

        return `${prefix}(${localDigits.slice(0, 3)}) ${localDigits.slice(3, 6)}-${localDigits.slice(6)}`.trim();
      };

      const validateNorthAmericanPhone = () => {
        if (!phoneInput) return true;

        const digits = getPhoneDigits(phoneInput.value);
        let errorMessage = '';

        if (digits.length > 0) {
          const isTenDigitNumber = digits.length === 10;
          const isElevenDigitNorthAmericaNumber = digits.length === 11 && digits.charAt(0) === '1';

          if (!isTenDigitNumber && !isElevenDigitNorthAmericaNumber) {
            errorMessage = 'Enter a valid 10-digit phone number.';
          }
        }

        phoneInput.setCustomValidity(errorMessage);
        return errorMessage === '';
      };

      const syncName = () => {
        const first = firstNameInput ? firstNameInput.value.trim() : '';
        const last = lastNameInput ? lastNameInput.value.trim() : '';
        hiddenNameInput.value = `${first} ${last}`.trim();
      };

      const getEmailErrorMessage = () => {
        if (!emailInput) return '';
        if (emailInput.validity.valueMissing) return 'Enter an email address.';
        if (emailInput.validity.typeMismatch) return 'Enter a valid email address.';
        return emailInput.validationMessage;
      };

      const showEmailError = () => {
        if (!emailInput) return;

        const message = getEmailErrorMessage();
        emailInput.setAttribute('aria-invalid', 'true');

        if (emailError) {
          emailError.textContent = message;
          emailError.hidden = false;
        }

        if (errorSummary && errorSummaryText) {
          errorSummaryText.textContent = message;
          errorSummary.hidden = false;
        }
      };

      const hideEmailError = () => {
        if (!emailInput) return;

        emailInput.removeAttribute('aria-invalid');

        if (emailError) {
          emailError.hidden = true;
        }

        if (errorSummary && errorSummaryText) {
          errorSummary.hidden = true;
          errorSummaryText.textContent = '';
        }
      };

      syncName();

      if (firstNameInput) {
        firstNameInput.addEventListener('input', syncName);
      }

      if (lastNameInput) {
        lastNameInput.addEventListener('input', syncName);
      }

      if (emailInput) {
        emailInput.addEventListener('invalid', showEmailError);

        emailInput.addEventListener('input', () => {
          if (emailInput.validity.valid) {
            hideEmailError();
          } else if (emailInput.getAttribute('aria-invalid') === 'true') {
            showEmailError();
          }
        });
      }

      if (phoneInput) {
        phoneInput.value = formatNorthAmericanPhone(phoneInput.value);
        validateNorthAmericanPhone();

        phoneInput.addEventListener('input', () => {
          phoneInput.value = formatNorthAmericanPhone(phoneInput.value);
          validateNorthAmericanPhone();
        });

        phoneInput.addEventListener('blur', () => {
          validateNorthAmericanPhone();
          phoneInput.reportValidity();
        });

        form.addEventListener('submit', (event) => {
          phoneInput.value = formatNorthAmericanPhone(phoneInput.value);

          if (!validateNorthAmericanPhone()) {
            event.preventDefault();
            phoneInput.reportValidity();
          }
        });
      }

      if (fileInput && fileLabel) {
        const defaultLabel = fileLabel.textContent;
        fileInput.addEventListener('change', () => {
          if (!fileInput.files || !fileInput.files.length) {
            fileLabel.textContent = defaultLabel;
            return;
          }

          fileLabel.textContent = fileInput.files[0].name;
        });
      }

      if (successDialog) {
        const closeButtons = successDialog.querySelectorAll('[data-contact-success-close]');

        if (typeof successDialog.showModal === 'function' && !successDialog.open) {
          successDialog.showModal();
        } else if (!successDialog.open) {
          successDialog.setAttribute('open', '');
        }

        closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (typeof successDialog.close === 'function') {
              successDialog.close();
            } else {
              successDialog.removeAttribute('open');
            }
          });
        });

        successDialog.addEventListener('click', (event) => {
          if (event.target === successDialog) {
            if (typeof successDialog.close === 'function') {
              successDialog.close();
            } else {
              successDialog.removeAttribute('open');
            }
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq-directory"] && !Shopify.designMode) return;
  try {
    
  const runFaqDirectoryOnReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  runFaqDirectoryOnReady(() => {
    const directories = document.querySelectorAll('[data-faq-directory]');
    if (!directories.length) return;

    directories.forEach((directory) => {
      const buttons = Array.from(directory.querySelectorAll('[data-faq-filter]'));
      const groups = Array.from(directory.querySelectorAll('[data-faq-category-group]'));
      if (!buttons.length || !groups.length) return;

      const setActiveFilter = (value) => {
        buttons.forEach((button) => {
          const buttonValue = button.getAttribute('data-faq-filter') || '';
          const isActive = buttonValue === value;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const applyFilter = (value) => {
        groups.forEach((group) => {
          const groupCategory = group.getAttribute('data-faq-category-group') || '';
          if (!value) {
            group.style.display = '';
            return;
          }

          group.style.display = groupCategory === value ? '' : 'none';
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextValue = button.getAttribute('data-faq-filter') || '';
          setActiveFilter(nextValue);
          applyFilter(nextValue);
        });
      });

      const initialValue = directory.getAttribute('data-faq-initial-category') || '';
      setActiveFilter(initialValue);
      applyFilter(initialValue);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits"] && !Shopify.designMode) return;
  try {
    
  const benefitIconImages = document.querySelectorAll('[data-benefit-svg-icon]');
  const preservedSvgPaints = ['none', 'transparent', '#fff', '#ffffff', 'white', 'rgb(255,255,255)', 'rgb(255 255 255)'];

  const normalizePaint = (paint) => paint.replace(/\s+/g, '').toLowerCase();

  const shouldRecolorPaint = (paint) => {
    if (!paint) return false;

    return !preservedSvgPaints.includes(normalizePaint(paint));
  };

  const inlineSvgStyles = (svg) => {
    svg.querySelectorAll('style').forEach((styleElement) => {
      const rulePattern = /([^{}]+)\{([^{}]+)\}/g;
      let ruleMatch;

      while ((ruleMatch = rulePattern.exec(styleElement.textContent)) !== null) {
        const selectors = ruleMatch[1].split(',').map((selector) => selector.trim()).filter(Boolean);
        const declarations = ruleMatch[2].split(';').map((declaration) => declaration.trim()).filter(Boolean);

        selectors.forEach((selector) => {
          let matchedElements = [];

          try {
            matchedElements = svg.querySelectorAll(selector);
          } catch (error) {
            return;
          }

          matchedElements.forEach((element) => {
            declarations.forEach((declaration) => {
              const separatorIndex = declaration.indexOf(':');
              if (separatorIndex === -1) return;

              const property = declaration.slice(0, separatorIndex).trim();
              const value = declaration.slice(separatorIndex + 1).trim();

              if (property && value) {
                element.style.setProperty(property, value);
              }
            });
          });
        });
      }

      styleElement.remove();
    });
  };

  const recolorSvg = (svg) => {
    svg.querySelectorAll('[fill]').forEach((element) => {
      if (shouldRecolorPaint(element.getAttribute('fill'))) {
        element.setAttribute('fill', 'currentColor');
      }
    });

    svg.querySelectorAll('[stroke]').forEach((element) => {
      if (shouldRecolorPaint(element.getAttribute('stroke'))) {
        element.setAttribute('stroke', 'currentColor');
      }
    });

    svg.querySelectorAll('[style]').forEach((element) => {
      if (shouldRecolorPaint(element.style.fill)) {
        element.style.fill = 'currentColor';
      }

      if (shouldRecolorPaint(element.style.stroke)) {
        element.style.stroke = 'currentColor';
      }
    });
  };

  benefitIconImages.forEach((image) => {
    fetch(image.currentSrc || image.src)
      .then((response) => response.text())
      .then((svgText) => {
        if (!svgText.includes('<svg')) {
          image.classList.add('product-benefits__icon--loaded');
          return;
        }

        const svgDocument = new DOMParser().parseFromString(svgText, 'image/svg+xml');
        const svg = svgDocument.querySelector('svg');

        if (!svg) {
          image.classList.add('product-benefits__icon--loaded');
          return;
        }

        inlineSvgStyles(svg);
        recolorSvg(svg);
        svg.classList.add('product-benefits__icon', 'product-benefits__icon--inline');
        svg.setAttribute('aria-hidden', 'true');
        image.replaceWith(svg);
      })
      .catch(() => {
        image.classList.add('product-benefits__icon--loaded');
      });
  });

  } catch(e) { console.error(e); }
})();
})();
